export default __webpack_public_path__ + "static/media/no-result.c8301e2a.svg";